interface RadioGroupField {
  editable?: string;
  value: {
    hint: string;
    label: string;
    options: {
      description: string;
      label: string;
      name: string;
      value: string;
    }[];
    requiredMessage: string;
  };
}

export default function mapScRadioToMap<T extends string>(data: RadioGroupField | undefined) {
  const resultMap = new Map<T | undefined, string>();

  for (const item of data?.value?.options ?? []) {
    resultMap.set(item.name as T, item.label);
  }
  return resultMap;
}
